import { createReducer, on } from '@ngrx/store';
import { initialLoggedInUserState } from './loggedInUser.state';
import { setLoggedInUser, clearLoggedInUser } from './loggedInUser.action';
export const loggedInUserReducer = createReducer(
    initialLoggedInUserState,
  on(setLoggedInUser, (state, { user }) => ({ ...state, loggedInUser : user })),
  on(clearLoggedInUser, state => ({ ...state, loggedInUser: null }))
);